import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  disconnectManatalIntegration,
  getManatalStatus,
  validateManatalIntegration,
} from "../services/integrations/manatal";
import { useAuth0 } from "@auth0/auth0-react";

export const manatalIntegrationKeys = {
  status: ["manatalIntegration", "status"] as const,
};

export const useManatalStatus = () => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery({
    queryKey: manatalIntegrationKeys.status,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const { data, error } = await getManatalStatus(token);
      if (error) throw new Error(error);
      return data;
    },
  });
};

export const useValidateManatalIntegration = () => {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation({
    mutationFn: async (apiKey: string) => {
      const token = await getAccessTokenSilently();
      const { data, error } = await validateManatalIntegration(apiKey, token);
      if (error) throw new Error(error);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: manatalIntegrationKeys.status });
    },
  });
};

export const useDisconnectManatalIntegration = () => {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();
      const { data, error } = await disconnectManatalIntegration(token);
      if (error) throw new Error(error);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: manatalIntegrationKeys.status });
    },
  });
};
